module.exports = __webpack_public_path__ + "static/media/finance-monitor-icon.a5719d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/finance-monitor-icon.png
// module id = 31
// module chunks = 0